// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import CrownOutlined from 'D:/Users/john/Documents/gitlab/vote_x1_admin_web/node_modules/@ant-design/icons/es/icons/CrownOutlined';
export default { CrownOutlined };
